const FLOATING_PLUGIN_TOOLBAR = "floating-plugin-toolbar";
export {
  FLOATING_PLUGIN_TOOLBAR
};
//# sourceMappingURL=data-hooks.js.map
